import { Suspense } from 'react'
import {
  PertoDigitalInjection,
  SecurityComponent
} from '@rededor/ap-core-frontend-react'

import { AppSetup } from '@/components/AppSetup'
import { AppThemeProvider } from '@/components/ThemeProvider'
import { AppReady } from '@/components/AppReady'
import { CartRecovery } from '@/components/CartRecovery'
import { NavigationEvents } from '@/components/NavigationEvents'
import { GenericErrorRedirect } from '@/components/GenericErrorRedirect'
import { PrefilledSummary } from '@/components/PrefilledSummary'

import { InjectStyles } from '@/app/InjectStyles'
import { InjectScripts } from '@/app/InjectScripts'

import { AppRoutes } from '@/routes'
import { appSettings } from '@/shared/consts/appSettings'

import '@/app/globals.scss'

export default function App() {
  return (
    <AppThemeProvider>
      <InjectStyles />
      <SecurityComponent
        clientId={appSettings.patientArea.clientId}
        application={appSettings.applicationName}
        baseURL={appSettings.patientArea.baseUrl}
        refreshTokenUrl={appSettings.patientArea.refreshTokenUrl}
        enableSessionExpiredRedirect={false}
        shouldFetchData={false}
        use403Redirect={false}
        verbose={false}
      >
        <PertoDigitalInjection />
      </SecurityComponent>
      <Suspense>
        <AppSetup />
        <AppReady />
        <GenericErrorRedirect />
        <AppRoutes />
        <section id="portal-root"></section>
        <InjectScripts />
        <NavigationEvents />
      </Suspense>
      <CartRecovery />
      <PrefilledSummary />
    </AppThemeProvider>
  )
}
